<template>
  <div class="wf-product-category-refinements">
    <div
      class="wf-product-refinement-list-new wf-product-refinement-list-expanded"
      v-for="filter in availableFilters"
      :key="filter.name"
    >
      <div>
        <button
          type="button"
          class="wf-product-refinement-list-header btn wf-product-refinement-list-header-toggle collapsed"
          data-toggle="collapse"
          :data-target="
            `.wf-product-refinement-collapse-${filter.azureFilterName
              .toLowerCase()
              .replace(/[^\w ]+/g, '')
              .replace(/ +/g, '-')}`
          "
        >
          {{ filter.name }}
          <span
            class="
              plus-sm-icon
              png-icon
              png-icon-icons-glyph--k-btn-minus-active
              wf-product-refinement-list-header-toggle-inactive
            "
          />
          <span
            class="
              plus-sm-icon
              png-icon
              png-icon-icons-glyph--k-btn-expand-ol
              wf-product-refinement-list-header-toggle-active
            "
          />
        </button>
      </div>
      <div
        class="wf-product-refinement-list-items collapse"
        :class="
          `wf-product-refinement-collapse-${filter.azureFilterName
            .toLowerCase()
            .replace(/[^\w ]+/g, '')
            .replace(/ +/g, '-')}`
        "
      >
        <div
          v-if="
            filter.azureFilterName.toLowerCase() ===
              inStockAzureName.toLowerCase()
          "
          class="in-stock-filter"
        >
          <div
            class="custom-control custom-switch psp-custom-switch wf-product-refinement-list-item ml-3"
          >
            <input
              type="checkbox"
              :checked="!!inStock"
              :disabled="isFetching == true"
              id="in-stock-swicth"
              style="width: 27px; z-index: 20"
              @click.stop="[inStock ? setInStock(null) : setInStock('0')]"
              class="custom-control-input"
            />
            <label class="custom-control-label" for="in-stock-swicth">
              {{ filter.name }}
            </label>
          </div>
          <div v-if="!!inStock">
            <!-- Change the select to an input text box similar to ShawContract -->
            <form onsubmit="return false;">
              <input
                type="text"
                id="inStockBox"
                name="inStockBox"
                :disabled="isFetching == true"
                size="10"
                @change="setInStock($event.currentTarget.value)"
                class="border-bottom-line"
                style="border:1px solid black; font-size:small"
                required
              />
              <span style="font-size:small"> {{ `${inStockUOM}` }}</span>
            </form>
          </div>
        </div>
        <div
          v-else-if="
            filter.azureFilterName.toLowerCase() ===
              faceWeightAzureName.toLowerCase()
          "
          class="face-weight-filter"
        >
          <div
            class="
              wf-product-refinement-list-item
              custom-control custom-checkbox
              mt-2
            "
          >
            <div>
              <input
                class="custom-control-input"
                type="checkbox"
                :disabled="isFetching == true"
                id="face-weight-filter-checkbox"
                :checked="filterByFaceWeight"
                value="face-weight-filter"
                @click="setFilterByFaceWeight(!filterByFaceWeight)"
              />
              <label
                class="custom-control-label"
                for="face-weight-filter-checkbox"
              >
                {{ $resourceString["product.Search.Filters.label.FilterFace"] }}
              </label>
            </div>
          </div>
          <div class="mt-3 mb-4 px-2">
            <vue-slider
              :value="faceWeightValue"
              :min="11"
              :max="70"
              :width="220"
              @change="faceWeightChange"
              :lazy="true"
              :marks="faceWeightValue"
              :disabled="!filterByFaceWeight"
            />
          </div>
        </div>
        <div v-else>
          <div
            class="
              wf-product-refinement-list-item
              custom-control custom-checkbox
            "
          >
            <div v-for="item in filter.options" :key="filter.name + '-' + item">
              <input
                class="custom-control-input"
                type="checkbox"
                :id="filter.name + '-' + item"
                :value="item"
                :disabled="isFetching == true"
                :checked="
                  selectedFilters[filter.azureFilterName] &&
                    selectedFilters[filter.azureFilterName].some(
                      i => i.toLowerCase() === item.toLowerCase()
                    )
                "
                @click="
                  onFilterClick({
                    filterName: filter.azureFilterName,
                    option: item
                  })
                "
              />
              <label
                :data-data="filter.azureFilterName"
                class="custom-control-label"
                :for="filter.name + '-' + item"
                :style="[
                  filter.name === 'Thickness'
                    ? { 'text-transform': 'lowercase' }
                    : {}
                ]"
              >
                {{
                  item == "1"
                    ? $resourceString[
                        `product.search.filters.current.${filter.azureFilterName.toLowerCase()}`
                      ]
                    : item
                }}
              </label>
            </div>
          </div>
          <div slot="showMoreLabel" slot-scope="{ isShowingMore }">
            <div class="btn view-more-button" v-if="isShowingMore">
              <span class="mr-1">{{
                $resourceString["product.search.side.filters.view.less"]
              }}</span>
              <span
                class="png-icon png-icon-icons-glyph--red-btn-minus-active"
              />
            </div>
            <div class="btn view-more-button" v-else>
              <span class="mr-1">{{
                $resourceString["product.search.side.filters.view.more"]
              }}</span>
              <span
                class="png-icon png-icon-icons-glyph--red-btn-expand-active"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: {
    VueSlider
  },
  computed: {
    ...mapGetters({
      filters: "filters/filters",
      selectedFilters: "filters/selectedFilters",
      inStock: "filters/inStock",
      faceWeightValue: "filters/faceWeightValue",
      filterByFaceWeight: "filters/filterByFaceWeight",
      isFetching: "productDisplay/isFetching"
    }),
    inStockUOM() {
      return this.selectedFilters?.InventoryType?.includes("Resilient")
        ? "SQF"
        : "SQY";
    },
    availableFilters() {
      //return only filters which have options but leave FaceWeight filter if is selected
      return this.filters.filter(
        f =>
          f.options.length ||
          (this.filterByFaceWeight &&
            f.azureFilterName === this.faceWeightAzureName)
      );
    }
  },
  data() {
    return {
      refinements: this.defaultRefinements,
      isMobileView: false,
      faceWeightAzureName: "FaceWeight",
      inStockAzureName: "InStock"
    };
  },
  methods: {
    ...mapActions({
      onFilterClick: "filters/onFilterClick",
      setInStock: "filters/setInStock",
      setFaceWeightValue: "filters/setFaceWeightValue",
      setFilterByFaceWeight: "filters/setFilterByFaceWeight"
    }),
    faceWeightChange(value) {
      this.setFaceWeightValue(value);
    }
  }
};
</script>
